var map = {
	"./BigBox.png": 4389,
	"./BlackHacks.png": 5620,
	"./CocoHR.png": 3111,
	"./CocoProcurement.png": 6535,
	"./CocoStore.png": 3640,
	"./E4T.png": 1978,
	"./ElectroChange.png": 7301,
	"./MyKibo.png": 9710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;